import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static targets = ["input"];
  static values = { url: { type: String, default: "/app/accounts/retrieve" } };

  connect() {
    this.handle();
  }

  handle() {
    if (this.inputTarget.value.length < 8) {
      return;
    }

    post(this.urlValue, {
      body: {
        account: { number: this.inputTarget.value },
      },
      responseKind: "turbo-stream",
    });
  }
}
